export default __webpack_public_path__ + "static/media/background.a9a9054c.jpg";